/* eslint-disable jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control */
import { React, PT, fetchApi, connect } from '@gasbuddy/react';
import { Modal, Header, Form, Button, Icon, Message, List } from 'semantic-ui-react';
import DatePicker from 'react-datepicker';

class BaseDelayModal extends React.Component {
  state = {}

  loadAndGo = () => {
    this.setState({ opened: true });
  }

  callApi = () => {
    const { rebillAfter } = this.state;
    const { accountId, transactionId } = this.props;
    this.setState({ }, async () => {
      const { body, status, error } = await fetchApi({
        url: `/payments/transaction/${accountId}/${transactionId}/prevent-bill`,
        catchErrors: true,
        body: { rebillAfter },
      });
      if (error || status !== 200) {
        this.setState({ error: body || error });
      } else {
        this.setState({ opened: false, error: null });
      }
    });
  }

  render() {
    const { opened, rebillAfter, error } = this.state;
    return (
      <Modal
        open={opened}
        trigger={<Button onClick={this.loadAndGo}>Prevent Re-Bill</Button>}
      >
        <Header icon="attention" content="Prevent Re-Billing" />
        <Modal.Content>
          {error
            && (
            <Message negative>
              <Message.Content>
                <List>
                  <List.Header>Cannot modify transaction:</List.Header>
                  {(error.log || []).map(l => (
                    <List.Item>
                      {l.message}
                    </List.Item>
                  ))}
                </List>
              </Message.Content>
            </Message>
            )
          }
          <Form>
            <Form.Field fluid>
              <label htmlFor="rebillAfter">Select Rebill Date, or Leave Blank To Block Indefinitely</label>
              <DatePicker
                id="rebillAfter"
                className="datetime"
                selected={rebillAfter}
                placeholderText="Block indefinitely"
                onChange={v => this.setState({ rebillAfter: v })}
              />
            </Form.Field>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button basic color="grey" onClick={() => this.setState({ opened: false })}>
            <Icon name="minus" />
            {' '}
            Cancel
          </Button>
          <Button basic color="blue" onClick={this.callApi}>
            <Icon name="eye" />
            {' '}
            Save
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

BaseDelayModal.propTypes = {
  accountId: PT.number,
  transactionId: PT.number,
};

BaseDelayModal.defaultProps = {
  transactionId: 0,
  accountId: 0,
};

export const DelayModal = connect(() => {})(BaseDelayModal);
